import resumePointsRequest from './resumePoints.request';
import createService from '../Utils/createService';
import handleServiceError from '../Utils/handleServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_RESUMEPOINTS,
} from '../../Errors/Constants/Error.retries';

const createResumePointsService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.RESUME_POINTS,
        configStoreUpdate$,
        resumePointsRequest,
        handleServiceError(ServiceTypes.RESUME_POINTS, handleError),
        RETRY_COUNT_API_SERVICE_RESUMEPOINTS,
    );

export default createResumePointsService;
